import React from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Layout from 'common/components/layout';
import Typography from 'common/components/tags/typography/Typography';
import Box from 'common/components/UI/box/Box';
import FAQ from 'common/components/UI/faq/FAQ';
import Loading from 'common/components/UI/loading/Loading';
import Button from 'common/components/tags/button/Button';

const DetailApp = () => {
  const { query } = useRouter();
  const router = useRouter();

  const content: Record<any, any> = {
    'mobile-site': {
      titlePage: 'Web App Info',
      title: 'Website PWA Version',
      content:
        "Apollon's PWA version makes renting a rental easier and more reliable",
      btnLabel: 'PWA version',
      link: 'https://apollon.uk.com',
    },
    'iphone-app': {
      titlePage: 'IPhone App Info',
      title: 'IPhone App',
      content:
        "Apollon's iPhone app makes renting a rental easier and more reliable",
      btnLabel: 'Download app',
      link: 'https://apps.apple.com/us/app/apollon/id1672251268?platform=iphone',
    },
    'ipad-app': {
      titlePage: 'IPad App Info',
      title: 'IPad App',
      content:
        "Apollon's iPad app makes renting a rental easier and more reliable",
      btnLabel: 'Download app',
      link: 'https://apps.apple.com/us/app/apollon/id1672251268?platform=ipad',
    },
    'android-app': {
      titlePage: 'Android App Info',
      title: 'Android App',
      content:
        "Apollon's Android app makes renting a rental easier and more reliable",
      btnLabel: 'Download app',
      link: 'https://play.google.com/store/apps/details?id=com.apollon.apollonApp',
    },
  };

  const contentList = [
    'Search for a property using advanced search',
    'List your rental property',
    'A property ad with a real estate agency (cost-effective and monthly subscription)',
    'Make your searches and properties easy to access again by saving them',
    'Send a request for a visit and rental',
    'Confidence in signing digital contracts',
    'Protection for your deposits',
    'Scanning contracts with AI',
    'etc.',
  ];

  if (
    query.slug &&
    !['mobile-site', 'iphone-app', 'ipad-app', 'android-app'].includes(
      String(query.slug)
    )
  ) {
    router.back();
    return <Loading />;
  } else {
    return (
      <>
        <Head>
          <title>{content[String(query.slug)]?.titlePage}</title>
        </Head>
        <Layout>
          <section className='section-space container'>
            <div className='grid grid-cols-8 items-center rounded-3 bg-primary p-6'>
              <div className=' col-span-8 md:col-span-6 xl:py-[4rem] xl:px-[4.5rem]'>
                <Typography
                  tag='h2'
                  color='white'
                  className='pt-[4.2rem] md:pt-0'
                >
                  {content[String(query.slug)]?.title}
                </Typography>
                <Typography
                  variant='h4-card'
                  className='pt-2 md:pt-4'
                  color='white'
                >
                  {content[String(query.slug)]?.content}
                </Typography>
              </div>
              <div className=' order-first col-span-8 md:order-last md:col-span-2'>
                <img
                  src={'/img/' + query.slug + '.svg'}
                  className=' mx-auto md:mx-0'
                />
              </div>
            </div>
          </section>
          <section className='container'>
            <Box>
              <Typography tag='h2'>
                A list of the services that this version of Apollon offers:
              </Typography>
              <ul className='list-disc pl-4 pt-4 text-gray1'>
                {contentList.map((item, index) => (
                  <li key={index}>
                    <Typography variant='p3'>{item}</Typography>
                  </li>
                ))}
              </ul>
              <Button
                label={content[String(query.slug)]?.btnLabel}
                variant='text'
                type='link'
                path={content[String(query.slug)]?.link}
                className='mt-3 pl-0'
                iconClassName='arrow-right'
                icon_align='right'
                target='_blank'
              />
            </Box>
          </section>
          <section className='section-space-t'>
            <FAQ title='Frequently asked questions' />
          </section>
        </Layout>
      </>
    );
  }
};

export default DetailApp;
